enum DistributionMethod {
  EMAIL = 0,
  LINK = 1,
}

export default DistributionMethod;
